module.exports = __webpack_public_path__ + "static/img/get_bunnyposy.5ae02a14.png";